import "./Header.css";
import Hamburger from "hamburger-react";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setClearIsFormSended,
  setIsClose,
} from "../../redux/ModalSlice/ModalSlice";
import {
  setBurgerIsActive,
  setBurgerIsClose,
} from "../../redux/BurgerSlice/BurgerSlice";
import Triangle from "./Triangle/Triangle";
import logo from "../../assets/images/logo.png";
import LanguageSwitcher from "./LanguageSwitcher/LanguageSwitcher";

const texts = {
  ua: {
    services: "Продукція",
    service1: "Молоко",
    service2: "Масло",
    service3: "Кисломолочні продукти",
    service4: "Крафтові продукти",
    about: "Про нас",
    production: "Виробництво",
    pastoral: "Pastoral",
    mumulya: "Мумуля",
    recipes: "Рецепти",
    blog: "Блог",
    cooperation: "Співпраця",
    contacts: "Контакти",
    request: "Зворотній зв'язок",
    politics: "Політики",
  },
  ru: {
    services: "Продукция",
    service1: "Молоко",
    service2: "Масло",
    service3: "Кисломолочные продукты",
    service4: "Крафтовые продукты",
    about: "О нас",
    production: "Производство",
    pastoral: "Pastoral",
    mumulya: "Мумуля",
    recipes: "Рецепты",
    blog: "Блог",
    cooperation: "Сотрудничество",
    contacts: "Контакты",
    request: "Contact us",
    career: "Career",
    politics: "Politics",
  },
};

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isActive = useSelector((state) => state.burger.isBurgerActive);
  const [isOpen, setOpen] = useState(isActive);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isAboutMenuActive, setIsAboutMenuActive] = useState(false);


  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  const t = texts[currentLang];
  const isRu = currentLang === "ru";

  const handleMenuOpen = () => {
    setIsMenuActive(true);
    setIsAboutMenuActive(false);
  };

  const handleMenuClose = () => {
    setIsMenuActive(false);
  };

  const handleAboutMenuClose = () => {
    setIsAboutMenuActive(false);
  };

  useEffect(() => {
    setOpen(isActive);
  }, [isActive]);

  const handleAboutMenuOpen = () => {
    setIsMenuActive(false);
    setIsAboutMenuActive(true);
  };


  const handleBurgerClose = () => {
    dispatch(setBurgerIsClose());
  };

  useEffect(() => {
    setOpen(isActive);
  }, [isActive]);

  return (
    <header className="header">
      <div className="header__wrapper">
        <Link className="header__logo-link" to={`${langPrefix}/`}>
        <img src={logo} alt="Pastoral logo" className="header__logo" />
        </Link>
        <nav className="header__nav">
          <div className="header__link-first" onMouseEnter={handleMenuOpen}>
            <div
              onMouseLeave={handleMenuClose}
              className={`header__menu ${isMenuActive ? "active" : ""}`}
            >
              <Link
                onClick={handleMenuClose}
                to={`${langPrefix}${"/milk/"}`}
                className={`header__menu-link mont-r-21`}
              >
                {t.service1}
              </Link>
              <Link
                onClick={handleMenuClose}
                to={`${langPrefix}${"/butter/"}`}
                className={`header__menu-link mont-r-21`}
              >
                {t.service2}
                </Link>
              <Link
                onClick={handleMenuClose}
                to={`${langPrefix}${"/fermented-milk-products/"}`}
                className={`header__menu-link $ mont-r-21`}
              >
                {t.service3}
                </Link>
              <Link
                onClick={handleMenuClose}
                to={`${langPrefix}${"/craft-products/"}`}
                className={`header__menu-link mont-r-21`}
              >
                {t.service4}
                </Link>
            </div>
            <p className={`header__nav-link first ${isMenuActive ? "active" : ""} mont-r-21`}>
              {t.services}
            </p>
            <div className={`triangle ${isMenuActive ? "active" : ""} `}>
              {" "}
              <Triangle isActive={isMenuActive} />
            </div>
          </div>
          <div className={`header__link-second ${isRu ? "ru" : ""}`} onMouseEnter={handleAboutMenuOpen}>
            <div
              onMouseLeave={handleAboutMenuClose}
              className={`header__menu second ${isAboutMenuActive ? "active" : ""}`}
            >
              <Link
                onClick={handleAboutMenuClose}
                to={`${langPrefix}${"/about-us/production/"}`}
                className={`header__menu-link mont-r-21`}
              >
                {t.production}
              </Link>
              <Link
                onClick={handleAboutMenuClose}
                to={`${langPrefix}${"/about-us/pastoral/"}`}
                className={`header__menu-link mont-r-21`}
              >
                {t.pastoral}
                </Link>
              <Link
                onClick={handleAboutMenuClose}
                to={`${langPrefix}${"/about-us/mumulya/"}`}
                className={`header__menu-link $ mont-r-21`}
              >
                {t.mumulya}
                </Link>
            </div>
            <p className={`header__nav-link first ${isAboutMenuActive ? "active" : ""} mont-r-21`}>
              {t.about}
            </p>
            <div className={`triangle ${isAboutMenuActive ? "active" : ""} `}>
              {" "}
              <Triangle isActive={isAboutMenuActive} />
            </div>
          </div>
          <Link to={`${langPrefix}/recipes/`} className="header__nav-link mont-r-21">
            {t.recipes}
          </Link>
          <Link to={`${langPrefix}/blog/`} className="header__nav-link mont-r-21">
            {t.blog}
          </Link>
          <Link to={`${langPrefix}/cooperation`} className="header__nav-link mont-r-21">
            {t.cooperation}
          </Link>
          <Link to={`${langPrefix}/contacts`} className="header__nav-link mont-r-21">
            {t.contacts}
          </Link>
        </nav>
        <div className="header__buttons">
            <LanguageSwitcher />
            <div className="burger__button">
              <Hamburger
                size={28}
                color="#000"
                toggled={isOpen}
                onToggle={(toggled) => {
                  if (toggled) {
                    dispatch(setIsClose());
                    dispatch(setBurgerIsActive());
                    dispatch(setClearIsFormSended());
                    setOpen(true);
                  } else {
                    dispatch(setBurgerIsClose());
                    setOpen(false);
                  }
                }}
              />
            </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
